import CloseIcon from '@mui/icons-material/Close'
import { Chip, SxProps } from '@mui/material'
import { useThemeMode } from '../../context/theme_mode_context'

interface Props {
    name: string
    value: string
    handleRemove(): void
    sx?: SxProps
}

export const FilterBox = ({ name, value, handleRemove, sx }: Props) => {
    const { mode } = useThemeMode()
    const isDark = mode === 'dark'

    return (
        <Chip
            label={`${name}: ${value}`}
            onDelete={handleRemove}
            deleteIcon={
                <CloseIcon
                    sx={{
                        color: isDark ? '#A5B4FC' : 'rgba(79, 70, 229, 0.9)',
                        fontSize: '16px',
                        '&:hover': {
                            color: isDark ? '#C7D2FE' : 'primary.main',
                        },
                    }}
                />
            }
            sx={{
                mt: '10px',
                ml: { xs: '0', md: '8px' },
                backgroundColor: isDark
                    ? 'rgba(129, 140, 248, 0.16)'
                    : 'rgba(79, 70, 229, 0.1)',
                color: isDark ? '#C7D2FE' : 'var(--text-primary)',
                border: isDark ? '1px solid rgba(129, 140, 248, 0.3)' : 'none',
                fontWeight: 500,
                fontSize: { xs: '12px', md: '13px' },
                height: 'auto',
                py: '4px',
                '& .MuiChip-deleteIcon': {
                    margin: '0 6px 0 -4px',
                },
                ...sx,
            }}
        />
    )
}
